import type { RootState } from '@/app/store';

export const selectTimeSeriesSoftTags = (state: RootState) =>
  state.materialSoftTag.timeSeriesSoftTags;

export const selectTimeSeriesSoftTagLoading = (state: RootState) =>
  state.materialSoftTag.loading;

export const selectTimeSeriesSoftTagError = (state: RootState) =>
  state.materialSoftTag.error;

export const selectTagMappingData = (state: RootState) =>
  state.materialSoftTag.createMappingData;

export const selectTagMappingLoading = (state: RootState) =>
  state.materialSoftTag.createMappingLoading ||
  state.materialSoftTag.deleteMappingLoading ||
  state.materialSoftTag.updateMappingLoading;

export const selectTagMappingError = (state: RootState) =>
  state.materialSoftTag.createMappingError ||
  state.materialSoftTag.deleteMappingError ||
  state.materialSoftTag.updateMappingError;
